module.exports = __webpack_public_path__ + "img/85.ade28d33.svg";